// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  position: relative;
  border-radius: var(--border-radius-large);
  border: var(--border-solid);
  padding: var(--spacing-large);
  gap: var(--spacing-extra-large);
  max-width: 430px;
  width: 100%;
  overflow: hidden;
  opacity: 0;
  z-index: 10;
  transform: translateY(100px);
  transition:
    opacity 0.5s ease,
    transform 0.5s ease;
}

.title-container {
  gap: var(--spacing-base);
}

.card-title {
  position: relative;
  gap: var(--spacing-extra-small);
  overflow: hidden;
}

.card-title p {
  font-size: var(--font-size-base);
}

.theme-container {
  gap: var(--spacing-base);
  height: 100%;
}

@keyframes slide-in-up {
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.card.animate-in {
  animation: slide-in-up 0.8s ease forwards;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/structural/card.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B;;uBAEqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":[".card {\n  position: relative;\n  border-radius: var(--border-radius-large);\n  border: var(--border-solid);\n  padding: var(--spacing-large);\n  gap: var(--spacing-extra-large);\n  max-width: 430px;\n  width: 100%;\n  overflow: hidden;\n  opacity: 0;\n  z-index: 10;\n  transform: translateY(100px);\n  transition:\n    opacity 0.5s ease,\n    transform 0.5s ease;\n}\n\n.title-container {\n  gap: var(--spacing-base);\n}\n\n.card-title {\n  position: relative;\n  gap: var(--spacing-extra-small);\n  overflow: hidden;\n}\n\n.card-title p {\n  font-size: var(--font-size-base);\n}\n\n.theme-container {\n  gap: var(--spacing-base);\n  height: 100%;\n}\n\n@keyframes slide-in-up {\n  from {\n    transform: translateY(100px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.card.animate-in {\n  animation: slide-in-up 0.8s ease forwards;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
